<template>
  <div>
    <div class="text-center" v-show="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-form @submit.prevent="submit" v-if="!isLoading">
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.azmoon_name"
            label-for="azmoon_name"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.azmoon_name"
              :rules="$v.azmoon_name.$params"
            />
            <b-form-input
              id="azmoon_name"
              type="text"
              :autocomplete="$lang.azmoonLang.azmoon_name"
              v-model="$v.azmoon_name.$model"
              :state="$v.azmoon_name.$dirty ? !$v.azmoon_name.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="azmoon_name-feedback"
              >{{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.azmoon_name)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.sample_name"
            label-for="sample_name"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.sample_name"
              :rules="$v.sample_name.$params"
            />
            <b-form-input
              id="sample_name"
              type="text"
              :autocomplete="$lang.sample_name"
              v-model="$v.sample_name.$model"
              :state="$v.sample_name.$dirty ? !$v.sample_name.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="sample_name-feedback"
              >{{
                $lang.azmoonLang.error_required | replace($lang.sample_name)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.azmoon_description"
            :rules="$v.azmoon_description.$params"
          />
          <Editor dir="rtl" v-model="$v.azmoon_description.$model"></Editor>

          <div class="invalid-feedback" v-if="!$v.azmoon_description.required">
            {{
              $lang.azmoonLang.error_required
                | replace($lang.azmoonLang.azmoon_description)
            }}
          </div>
        </b-col>
        <b-col cols="12" md="6" class="white-space mt-2">
          <b-form-checkbox
            id="is_repeat_description"
            v-model="is_repeat_description"
            name="is_repeat_description"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.is_repeat_description }}
            <span
              v-b-tooltip.hover
              :title="$lang.azmoonLang.is_repeat_description_tooltip"
            >
              <i class="fa fa-info-circle fa-lg text-info"></i>
            </span>
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" md="12" class="mt-3">
          <b-card>
            <div slot="header">
              <strong v-text="$lang.timing" />
            </div>
            <b-row>
              <b-col cols="12" class="mb-3">
                <requiredComponent
                  slot="label"
                  :label="$lang.azmoonLang.duration_apply"
                  :rules="$v.duration_apply_selected.$params"
                />
                <b-button-group class="mt-2">
                  <b-button
                    v-for="(button, buttonKey) in duration_apply_options"
                    :key="buttonKey"
                    :pressed="
                      pathOr(null, ['value'], duration_apply_selected) ===
                      button.value
                    "
                    variant="outline-primary"
                    v-text="button.text"
                    @click="selectDurationApply(button)"
                  />
                </b-button-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label-for="duration"
                  :label-cols="$config.azmoon.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.show_duration}(${$lang.azmoonLang.minute})`"
                    :rules="$v.duration.$params"
                    :showInfo="true"
                    :titleText="$lang.azmoonLang.duration_tooltip"
                  />
                  <b-form-input
                    id="duration"
                    type="number"
                    min="0"
                    max="999"
                    autocomplete="off"
                    v-model="$v.duration.$model"
                    :state="$v.duration.$dirty ? !$v.duration.$error : null"
                  />
                  <div class="invalid-feedback" v-if="!$v.duration.required">
                    {{
                      $lang.azmoonLang.error_required
                        | replace($lang.show_duration)
                    }}
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="
                      $v.duration.required &&
                      (!$v.duration.minLengh || !$v.duration.maxLengh)
                    "
                  >
                    {{
                      $lang.azmoonLang.error_Value
                        | replace($lang.show_duration, "0", "999")
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                class="mb-3"
                v-if="
                  pathOr(null, ['value'], duration_apply_selected) === 1 &&
                  duration
                "
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.exam_pack_start_time_kind"
                  :rules="$v.start_time_kind_selected.$params"
                />
                <b-button-group class="mt-2">
                  <b-button
                    v-for="(button, buttonKey) in start_time_kind_options"
                    :key="buttonKey"
                    :pressed="
                      pathOr(null, ['value'], start_time_kind_selected) ===
                      button.value
                    "
                    variant="outline-primary"
                    v-text="button.text"
                    @click="selectExamPackStartTimeKind(button)"
                  />
                </b-button-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.question_per_page"
            label-for="question_per_page"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.question_per_page"
              :rules="$v.question_per_page.$params"
            />
            <b-form-input
              id="question_per_page"
              type="text"
              :autocomplete="$lang.azmoonLang.question_per_page"
              v-model="$v.question_per_page.$model"
              :state="
                $v.question_per_page.$dirty
                  ? !$v.question_per_page.$error
                  : null
              "
            >
            </b-form-input>
            <b-form-invalid-feedback id="question_per_page-feedback">
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.question_per_page)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.question_numbering_start"
            label-for="question_numbering_start"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.question_numbering_start"
              :rules="$v.question_numbering_start.$params"
              :showInfo="true"
              :titleText="$lang.azmoonLang.question_numbering_start_tooltip"
            />
            <b-form-input
              id="question_numbering_start"
              type="number"
              min="0"
              max="999"
              :autocomplete="$lang.azmoonLang.question_numbering_start"
              v-model="$v.question_numbering_start.$model"
              :state="
                $v.question_numbering_start.$dirty
                  ? !$v.question_numbering_start.$error
                  : null
              "
            >
            </b-form-input>

            <div
              class="invalid-feedback"
              v-if="!$v.question_numbering_start.required"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.question_numbering_start)
              }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                $v.question_numbering_start.required &&
                (!$v.question_numbering_start.minLengh ||
                  !$v.question_numbering_start.maxLengh)
              "
            >
              {{
                $lang.azmoonLang.error_Value
                  | replace(
                    $lang.azmoonLang.question_numbering_start,
                    "0",
                    "999"
                  )
              }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.correction_method_algorithm_id"
            label-for="correction_method_algorithm_id"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.correction_method_algorithm_id"
              :rules="$v.correction_method_algorithm_id.$params"
            />
            <selectFind
              :options="correction_method_algorithm_options"
              v-model="$v.correction_method_algorithm_id.$model"
              label="caption"
              id="id"
              :loading="correction_method_algorithm_loading"
              :isValid="
                $v.correction_method_algorithm_id.$dirty
                  ? !$v.correction_method_algorithm_id.$error
                  : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.correction_method_algorithm_id.$error
                  ? 'block'
                  : 'none',
              }"
              id="correction_method_algorithm_id_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.correction_method_algorithm_id)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="show_as_final"
            v-model="show_as_final"
            name="show_as_final"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.show_as_final }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="hidden_question_title"
            v-model="hidden_question_title"
            name="hidden_question_title"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.hidden_question_title }}
            <span
              v-b-tooltip.hover
              :title="$lang.azmoonLang.hidden_question_title_tooltip"
            >
              <i class="fa fa-info-circle fa-lg text-info"></i
            ></span>
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="random_display_questions"
            v-model="random_display_questions"
            name="random_display_questions"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.random_display_questions }}
            <span
              v-b-tooltip.hover
              :title="$lang.azmoonLang.random_display_questions_tooltip"
              ><i class="fa fa-info-circle fa-lg text-info"></i
            ></span>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="is_only_one_answer"
            v-model="is_only_one_answer"
            name="is_only_one_answer"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.is_only_one_answer }}
            <span
              v-b-tooltip.hover
              :title="$lang.azmoonLang.is_only_one_answer_tooltip"
            >
              <i class="fa fa-info-circle fa-lg text-info"></i
            ></span>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12" class="white-space my-2">
          <b-form-checkbox
            id="is_show_as_form"
            v-model="is_show_as_form"
            name="is_show_as_form"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.is_show_as_form }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12">
          <b-alert :show="duration > 0">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <b v-text="$lang.is_answer_to_all_question_alert_message" />
          </b-alert>
        </b-col>
        <b-col cols="12" md="12" class="white-space">
          <b-form-checkbox
            id="is_answer_to_all_question"
            v-model="is_answer_to_all_question"
            name="is_answer_to_all_question"
            value="1"
            unchecked-value="0"
            :disabled="duration > 0"
          >
            {{ $lang.azmoonLang.is_answer_to_all_question }}
            <span
              v-b-tooltip.hover
              :title="$lang.azmoonLang.is_answer_to_all_question_tooltip"
              ><i class="fa fa-info-circle fa-lg text-info"></i
            ></span>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="allow_multiple_answer"
            v-model="allow_multiple_answer"
            name="allow_multiple_answer"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.allow_multiple_answer }}
            <span
              v-b-tooltip.hover
              :title="$lang.azmoonLang.allow_multiple_answer_tooltip"
              ><i class="fa fa-info-circle fa-lg text-info"></i
            ></span>
          </b-form-checkbox>
        </b-col>

        <b-col class="mt-2" cols="12" v-if="mode == `edit`">
          <QuestionPreview
            :id="1"
            ref="questionPreview"
            :allowCollapse="true"
            :showInfo="true"
            :tooltipText="$lang.azmoonLang.examPackPreview"
            :question_title="questionTitle"
            :options="
              question &&
              question.question_info &&
              question.question_info.options
            "
            :title="$lang.azmoonLang.questions_preview"
            :question_kind="1"
            @changeDisplayStyle="getDisplayStyle"
            @changeOptionShowKind="getOptionShowKind"
            @changeColNumber="changeColNumber"
            @changeDisplayMode="changeDisplayMode"
          />
        </b-col>
        <b-col cols="12" md="12">
          <div class="form-group form-btn text-right">
            <b-button type="submit" size="md" variant="success">
              {{ $lang.azmoonLang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              class="ml-2"
              size="md"
              variant="danger"
              @click="handleBack"
            >
              {{ $lang.azmoonLang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import QuestionPreview from "./../preview/questionPreview";
import Editor from "@/components/ckeditor/editor";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { renderEumOptions, generateApiUrl } from "@/shared/utils";

import { createPureDom } from "@/shared/utils";
export default {
  name: "exam-pack-form",
  inject: ["examPackQuestionRepository"],
  components: {
    Editor,
    QuestionPreview,
  },
  validations: {
    azmoon_description: {},
    duration: {
      required,
    },
    azmoon_name: {
      required,
    },
    duration_apply_selected: {
      required,
    },
    start_time_kind_selected: {},
    question_numbering_start: {
      required,
    },
    correction_method_algorithm_id: {
      required,
    },
    question_per_page: {},
    sample_name: { required },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      duration: 0,
      question_per_page: 10,
      is_repeat_description: 0,
      display_style_selected: null,
      show_kind_selected: null,
      display_count: null,
      azmoon_name: null,
      azmoon_description: null,
      duration_apply_selected: { value: 1, text: "آزمون" },
      start_time_kind_selected: {
        value: 1,
        text: "مشاهده این پرسشنامه",
      },
      allow_multiple_answer: 0,
      hidden_question_title: 0,
      question_numbering_start: 1,
      random_display_questions: 0,
      show_as_final: 0,
      parent_options: [],
      question: [],
      parent_Loading: 0,
      is_only_one_answer: 0,
      is_show_as_form: 0,
      is_answer_to_all_question: 0,
      display_mode: {},
      questionTitle: null,
      questionExamPackCount: 0,
      correction_method_algorithm_options: [],
      correction_method_algorithm_loading: false,
      correction_method_algorithm_id: null,
      sample_name: null,
    };
  },
  watch: {
    duration(value) {
      if (value) {
        this.is_answer_to_all_question = 0;
      }
    },
  },
  computed: {
    duration_apply_options() {
      return renderEumOptions("duration_apply_method");
    },
    start_time_kind_options() {
      return renderEumOptions("start_time_kind");
    },
    question_selection_algorithm_options() {
      return renderEumOptions("question_selection_algorithm");
    },
  },
  async created() {
    await this.getCorrectionMethodAlgorithmCombo();
    this.fetchData();
  },
  methods: {
    createPureDom,
    pathOr,
    getOptionShowKind(item) {
      this.show_kind_selected = item;
    },
    getDisplayStyle(item) {
      this.display_style_selected = item;
    },
    changeColNumber(item) {
      this.display_count = item.value;
    },
    changeDisplayMode(item) {
      this.display_mode = item;
    },
    handleBack() {
      this.$emit("handleBack");
    },
    async getParent() {
      try {
        this.parent_Loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url + this.$config.azmoon.exam_pack_all
        );
        let data = response.data.data.map((x) => {
          return {
            text: x.exam_pack_name,
            value: x.id,
          };
        });
        this.parent_options = data;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parent_Loading = false;
      }
    },
    async getQuestionExamPack() {
      try {
        const response = await this.examPackQuestionRepository.find(
          this.item.id
        );
        let data = response.data.data.result;
        this.questionExamPackCount = data && data.length;
        this.question = data[0] ? data[0] : null;
        if (this.question)
          this.questionTitle =
            this.question &&
            this.question.question_info &&
            this.question.question_info.title &&
            this.question.question_info.title.title_description;
      } catch (error) {
        this.$generateError(error);
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        duration: this.duration,
        exam_pack_name: this.azmoon_name,
        exam_pack_show_name: this.sample_name,
        question_per_page: this.question_per_page,
        exam_pack_description: this.azmoon_description,
        duration_apply_method_id: pathOr(
          null,
          ["value"],
          this.duration_apply_selected
        ),
        start_time_kind_id: pathOr(
          null,
          ["value"],
          this.start_time_kind_selected
        ),
        hidden_question_title: this.hidden_question_title,
        question_numbering_start: this.question_numbering_start,
        correction_method_algorithm_id:
          this.correction_method_algorithm_id &&
          this.correction_method_algorithm_id.id,
        show_as_final: this.show_as_final,
        display_style_id:
          this.display_style_selected && this.display_style_selected.value,
        option_show_kind_id:
          this.show_kind_selected && this.show_kind_selected.value,
        display_count: this.display_count,
        display_mode_id: this.display_mode && this.display_mode.value,
        allow_multiple_answer: this.allow_multiple_answer,
        random_display_questions: this.random_display_questions,
        is_only_one_answer: +this.is_only_one_answer,
        is_show_as_form: this.is_show_as_form,
        is_answer_to_all_question: this.is_answer_to_all_question,
        is_repeat_description: this.is_repeat_description,
      };
      this.$emit("submit", payload);
    },
    async fetchData() {
      if (
        this.item &&
        Object.keys(this.item).length > 0 &&
        this.mode == "edit"
      ) {
        await this.getQuestionExamPack();
        this.duration = this.item.duration;
        this.azmoon_name = this.item.exam_pack_name;
        this.sample_name = this.item.exam_pack_show_name;
        this.azmoon_description = createPureDom(
          this.item.exam_pack_description
        );
        this.hidden_question_title = this.item.hidden_question_title;
        this.question_numbering_start = this.item.question_numbering_start;
        this.is_only_one_answer = this.item.is_only_one_answer;
        this.is_show_as_form = this.item.is_show_as_form;
        this.is_answer_to_all_question = this.item.is_answer_to_all_question;
        this.question_per_page = this.item.question_per_page;
        this.random_display_questions = this.item.random_display_questions;
        this.show_as_final = this.item.show_as_final;
        this.is_repeat_description = this.item.is_repeat_description;
        this.allow_multiple_answer = this.item.allow_multiple_answer;
        if (this.item.display_mode) {
          let text_exam_pack =
            this.item.display_mode && this.item.display_mode.caption;
          let value_exam_pack =
            this.item.display_mode && this.item.display_mode.id;
          this.$refs.questionPreview.display_mode_selected = {
            text: text_exam_pack,
            value: value_exam_pack,
          };
          this.display_mode = this.$refs.questionPreview.display_mode_selected;
        }
        if (this.item.display_mode && this.item.display_mode.value !== null) {
          await this.$refs.questionPreview.getOptionShowKind();
        }
        if (this.item.display_style) {
          let text_exam_pack = this.item.display_style.caption;
          let value_exam_pack = this.item.display_style.id;
          this.$refs.questionPreview.status_selected = {
            text: text_exam_pack,
            value: value_exam_pack,
          };
          this.display_style_selected =
            this.$refs.questionPreview.status_selected;
        }
        if (this.item.option_show_kind) {
          let text_exam_pack = this.item.option_show_kind.caption;
          let value_exam_pack = this.item.option_show_kind.id;
          this.$refs.questionPreview.show_kind_selected = {
            text: text_exam_pack,
            value: value_exam_pack,
          };
          this.show_kind_selected =
            this.$refs.questionPreview.show_kind_selected;
        }
        if (this.item.display_count) {
          let value_exam_pack = this.item.display_count;
          this.$refs.questionPreview.col_number_selected =
            this.$refs.questionPreview.col_number_options.find(
              (x) => x.value == value_exam_pack
            );
          this.display_count =
            this.$refs.questionPreview.col_number_selected &&
            this.$refs.questionPreview.col_number_selected.value;
        }
        this.$emit("lengthQuestions", this.questionExamPackCount);

        // set enums selected
        this.duration_apply_selected = this.duration_apply_options.find(
          (x) =>
            x.value === pathOr(null, ["duration_apply_method", "id"], this.item)
        );

        this.start_time_kind_selected = this.start_time_kind_options.find(
          (x) => x.value === pathOr(null, ["start_time_kind", "id"], this.item)
        );
        this.correction_method_algorithm_id = pathOr(
          null,
          ["correction_method_algorithm"],
          this.item
        );
      }
    },
    async getCorrectionMethodAlgorithmCombo(search_txt) {
      /* if (!search_txt || search_txt.length < 2) {
        return;
      }
      if (search_txt.length > 2) {
        this.correction_method_algorithm_options = [];
      } */

      this.correction_method_algorithm_options = [];
      try {
        this.correction_method_algorithm_loading = true;
        const url = generateApiUrl(["azmoon", "analysis_algorithm_combo"]);
        const response = await this.$httpService.get(url);
        this.correction_method_algorithm_options = pathOr(
          [],
          ["data", "data"],
          response
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.correction_method_algorithm_loading = false;
      }
    },
    selectDurationApply(button) {
      this.duration_apply_selected = { ...button };
    },
    selectExamPackStartTimeKind(button) {
      this.start_time_kind_selected = { ...button };
    },
  },
};
</script>
